import React, { useRef, useState, useEffect, Suspense, Fragment } from "react";
import ShimmerLoader from "../ShimmerLoader";
const Biomarkers = React.lazy(() => import("."));

function BiomarkersLazyLoadWrapper(props) {
  const {Fullscreen, geneCancer,Highcharts,options,BiomarkersLoader} = props;
  const containerRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // BiomarkersAPICall();
          observer.disconnect(); 
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => observer.disconnect();
  /* eslint-disable-next-line react-hooks/exhaustive-deps */    
  }, []);
  return (
    <Fragment>
      <div ref={containerRef} 
      // style={{ minHeight: "500px" }}
      >
        {isVisible && (
          <Suspense fallback={<ShimmerLoader />}>
            {BiomarkersLoader === true && <ShimmerLoader />}
            {BiomarkersLoader === false && geneCancer && (
              <Biomarkers
                Fullscreen={Fullscreen}
                geneCancer={geneCancer}
                options={options}
                Highcharts={Highcharts}
              />
            )}
          </Suspense>
        )}
      </div>
    </Fragment>
  );
}

export default BiomarkersLazyLoadWrapper;
